import { useEffect } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router";

import { Button } from "@/components/ui/button";

const RELOAD_FLAG = "fin:reloaded-after-chunk-error";

function isStaleChunkError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(
    message,
  );
}

export function RouteError() {
  const error = useRouteError();
  const stale = isStaleChunkError(error);

  useEffect(() => {
    // After a deploy, old hashed chunks vanish: reload once to pick up the new build.
    if (stale && !sessionStorage.getItem(RELOAD_FLAG)) {
      sessionStorage.setItem(RELOAD_FLAG, "1");
      window.location.reload();
    }
  }, [stale]);

  const title = isRouteErrorResponse(error) ? `Error ${error.status}` : "Algo salió mal";
  const detail = stale
    ? "Hay una versión nueva de la aplicación."
    : error instanceof Error
      ? error.message
      : "Error inesperado";

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#f5f6fa] px-6 text-center text-[#1f2433] dark:bg-[#101315] dark:text-white" role="alert">
      <h1 className="text-2xl font-bold">{title}</h1>
      <p className="max-w-md text-sm text-[#8190b0]">{detail}</p>
      <Button className="bg-[#4077f6] text-white hover:bg-[#3268ea]" onClick={() => window.location.reload()}>
        Recargar
      </Button>
    </div>
  );
}
